import { render } from "./AdminPage.vue?vue&type=template&id=7edb6fec&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"

import "./AdminPage.vue?vue&type=style&index=0&id=7edb6fec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edb6fec"]])

export default __exports__